import { keys as analytics } from '@repo/analytics/keys';
import { keys as auth } from '@repo/auth/keys';
import { keys as email } from '@repo/email/keys';
import { keys as core } from '@repo/next-config/keys';
import { keys as security } from '@repo/security/keys';
import { createEnv } from '@t3-oss/env-nextjs';
import { keys as database } from './lib/db/keys';

export const env = createEnv({
  extends: [auth(), analytics(), core(), email(), security(), database()],
  server: {},
  client: {},
  runtimeEnv: {},
});
